var util = {};
util.isBlank = function (val) {
    return _.trim(val) == "";
}

util.isNotBlank = function (val) {
    return _.trim(val) != "";
}

util.isEmpty = function (val) {
    return val==null||val.length==0;
}

util.isNotEmpty = function (val) {
    return val!=null&&val.length>0;
}

util.contains = function (str, subStr) {
    if (subStr == null || subStr.length == 0) {
        return true;
    }
    var reg = eval("/" + subStr + "/ig");
    return reg.test(str);
}

util.bool2str = function (value) {
    if (value == "true" || value == true || value == "1" || value == 1) {
        return "是";
    } else {
        return "否";
    }
};


util.auditStatus2color = function (status) {
    if (status == "未通过") {
        return "danger";
    } else if(status == "已通过") {
        return "success";
    } else {
        return "primary";
    }
};


export default util;


// WEBPACK FOOTER //
// ./src/util/string.js